/*
 * Sezione "Video recensioni" - caricamento video estremamente pigro.
 *
 * A pagina caricata nel DOM non esiste alcun <video>: solo i poster. Il tag viene creato
 * al primo click sulla card, con la sorgente transcodata piu' leggera adatta alla larghezza
 * reale della card (480p su mobile invece di 1080p). Le card uscite dal viewport vengono
 * messe in pausa e, se gia' inattive, il loro <video> viene distrutto per non far crescere
 * la memoria mentre si scorre.
 */
(function () {
  'use strict';

  var conn = navigator.connection || {};
  var saveData = conn.saveData === true;
  var slowNet = /2g/i.test(conn.effectiveType || '');
  var warmed = false;

  /* Tetto al device pixel ratio usato per scegliere la qualita'. Senza tetto, un telefono
   * a DPR 3 chiede sempre la variante massima (1080p a 7,2 Mbps) per una card larga ~300px:
   * megabyte spesi per una nitidezza che su quel formato nessuno percepisce.
   *
   * A 1.15 tutti i telefoni, i tablet e i laptop fino a 1440 prendono la 720p (4,5 Mbps,
   * -38% di byte) e solo gli schermi davvero grandi, dove la card supera i 400px, salgono
   * alla 1080p. Valore scelto per esclusione: a 1.25 l'iPhone Max restava sulla 1080p,
   * a 1.0 il tablet scendeva alla 480p (troppo morbida su una card da 246px). */
  var DPR_CAP = 1.15;

  /* Pavimento di qualita'. Con 5 colonne su desktop le card scendono a ~224px a 1280px di
   * viewport, e il solo calcolo per DPR sceglierebbe la 480p: quella variante e' larga 270px,
   * cioe' meno dei pixel fisici del box su uno schermo retina, e si vede sgranata. Sotto la
   * 720p non si scende, a meno che il transcoding non abbia prodotto nient'altro. */
  var MIN_HEIGHT = 720;

  /* Sceglie la variante transcodata piu' piccola che copre la risoluzione richiesta. */
  function pickSource(sources, cardWidth) {
    var mp4 = sources
      .filter(function (s) {
        return s.mime_type === 'video/mp4' || s.format === 'mp4';
      })
      .sort(function (a, b) {
        return a.height - b.height;
      });

    // Se il transcoding non ha prodotto mp4 (solo HLS), meglio provare la prima
    // sorgente disponibile che lasciare la card morta al click.
    if (!mp4.length) return sources[0] || null;

    var dpr = Math.min(window.devicePixelRatio || 1, DPR_CAP);
    var needed = Math.max(cardWidth * dpr * (16 / 9), MIN_HEIGHT);

    for (var i = 0; i < mp4.length; i++) {
      if (mp4[i].height >= needed) return mp4[i];
    }
    return mp4[mp4.length - 1];
  }

  /* Apre la connessione al CDN prima ancora che serva: risparmia DNS+TLS al click. */
  function warm() {
    if (warmed) return;
    warmed = true;
    var link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://cdn.shopify.com';
    link.crossOrigin = '';
    document.head.appendChild(link);
  }

  function readSources(media) {
    try {
      return JSON.parse(media.dataset.vrSources || '[]');
    } catch (e) {
      return [];
    }
  }

  function build(media) {
    var existing = media.querySelector('video');
    if (existing) return existing;

    var picked = pickSource(readSources(media), media.clientWidth || 320);
    if (!picked) return null;

    var video = document.createElement('video');
    video.src = picked.url;
    video.playsInline = true;
    video.loop = true;
    video.muted = true;
    video.preload = 'auto';
    video.setAttribute('playsinline', '');
    video.setAttribute('disableremoteplayback', '');

    media.classList.add('is-loading');
    video.addEventListener(
      'canplay',
      function () {
        media.classList.remove('is-loading');
        media.classList.add('is-ready');
      },
      { once: true }
    );

    media.appendChild(video);
    return video;
  }

  function destroy(media) {
    var video = media.querySelector('video');
    if (!video) return;
    video.removeAttribute('src');
    video.load();
    video.remove();
    media.classList.remove('is-ready', 'is-loading', 'is-playing', 'is-muted');
    delete media.dataset.idle;
  }

  function init(root) {
    if (!root || root.dataset.vrInit === '1') return;
    root.dataset.vrInit = '1';

    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-vr-media]'));
    if (!medias.length) return;

    medias.forEach(function (media) {
      media.addEventListener('pointerenter', warm, { once: true, passive: true });
      media.addEventListener('touchstart', warm, { once: true, passive: true });

      var unmute = media.querySelector('[data-vr-unmute]');
      if (unmute) {
        unmute.addEventListener('click', function (event) {
          // Non deve arrivare al contenitore, altrimenti metterebbe in pausa il video.
          event.stopPropagation();
          var video = media.querySelector('video');
          if (!video) return;
          video.muted = false;
          media.classList.remove('is-muted');
          video.play().catch(function () {});
        });
      }

      // La card prodotto ora sta dentro il media: il click deve navigare al prodotto,
      // non mettere in pausa il video mentre si esce dalla pagina.
      var cta = media.querySelector('[data-vr-cta]');
      if (cta) {
        cta.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }

      media.addEventListener('click', function () {
        var video = build(media);
        if (!video) return;

        // Un solo video alla volta.
        medias.forEach(function (other) {
          if (other === media) return;
          var v = other.querySelector('video');
          if (v && !v.paused) {
            v.pause();
            other.classList.remove('is-playing');
            other.dataset.idle = '1';
          }
        });

        if (video.paused) {
          media.classList.add('is-playing');
          delete media.dataset.idle;

          // Il click e' un gesto utente, quindi l'audio e' consentito: una recensione
          // muta non serve a niente. Se il browser rifiuta comunque, si ripiega sul
          // muto e si mostra il tasto per riattivare l'audio.
          video.muted = false;
          media.classList.remove('is-muted');

          video.play().catch(function () {
            video.muted = true;
            media.classList.add('is-muted');
            video.play().catch(function () {
              media.classList.remove('is-playing', 'is-muted');
            });
          });
        } else {
          video.pause();
          media.classList.remove('is-playing');
          media.dataset.idle = '1';
        }
      });
    });

    /* Gestione memoria: pausa fuori viewport, distruzione quando e' del tutto fuori. */
    if ('IntersectionObserver' in window) {
      var memory = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var media = entry.target;
            var video = media.querySelector('video');

            if (!entry.isIntersecting && video && !video.paused) {
              video.pause();
              media.classList.remove('is-playing');
              media.dataset.idle = '1';
            }

            if (entry.intersectionRatio === 0 && media.dataset.idle === '1') {
              destroy(media);
            }
          });
        },
        { threshold: [0, 0.25] }
      );
      medias.forEach(function (media) {
        memory.observe(media);
      });
    }

    /* Prefetch opportunistico della sola prima card, mai su rete lenta o Risparmio dati. */
    if (saveData || slowNet) return;

    var idle =
      window.requestIdleCallback ||
      function (cb) {
        return setTimeout(cb, 1200);
      };

    idle(function () {
      var first = medias[0];
      if (!first || first.querySelector('video')) return;
      var picked = pickSource(readSources(first), first.clientWidth || 320);
      if (!picked) return;

      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'video';
      link.href = picked.url;
      document.head.appendChild(link);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vr-root]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: la sezione viene ricostruita da zero a ogni modifica.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
